import formErrorsSummaryComponent from './formErrorsSummary.component';

let formErrorsSummaryModule = angular.module('components.formErrorsSummary', [])

.component('formErrorsSummary', formErrorsSummaryComponent)

.name;

export default formErrorsSummaryModule;



// WEBPACK FOOTER //
// ./client/app/components/formErrorsSummary/formErrorsSummary.js